<template>
    <div>
        <nav-bar />

        <div id="wrapper" class="wrapper d-flex align-items-stretch">
            <div class="left-corner"></div>
            <div class="right-corner"></div>
            <side-bar />
            <div class="d-flex flex-column align-items-center position-relative w-100">
                <div class="banner-text" v-if="$store.state.user_info.contest_info.id != 0">
                    <div class="d-flex align-items-center gap-3">
                        <p class="banner-link">{{ $t('event_text_marquee', {
                            name: $store.state.user_info.contest_info.contest_name, start:
                                moment($store.state.user_info.contest_info.start_time).format('DD/MM/YYYY'), end: moment($store.state.user_info.contest_info.end_time).format('DD/MM/YYYY')
                        }) }}</p>

                        <a :href="$store.state.user_info.contest_info.upload_video_url" class="btn btn-orange-gradient d-flex gap-1 align-items-center" target="_blank"
                            v-if="$store.state.user_info.contest_info.id != 0 && $store.state.user_info.contest_info.upload_video_url && $store.state.user_info.contest_info.upload_video_url !== ''">
                            <AppIcon src="/themes/ito/images/icons/video_camera.svg" :size="21" />
                            <span>{{ $t('upload_video') }}</span>
                        </a>
                    </div>
                </div>
                <div class="container h-100 d-flex flex-column justify-content-between p-0 " :class="{ 'mt-5': $store.state.user_info.contest_info.id != 0 }">
                    <router-view>
                    </router-view>
                    <ModalHost />
                    <footer-element />
                </div>
            </div>

        </div>

        <div class="modal fade" id="selectLangModal" tabindex="-1" role="dialog" aria-labelledby="selectLangModal" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered popup-main-2" role="document">
                <div class="modal-content modal-body box-shadow-main">
                    <div class="close-popup" data-bs-dismiss="modal"></div>
                    <h3 class="popup-title mb-20">{{ $t('choose_language') }}</h3>
                    <div class="select-lang">

                        <div :class="locate == localize.lang ? 'select-lang-item active' : 'select-lang-item'" @click="setLocate(localize)" v-for="(localize, index) in localizes" :key="index">
                            <div class="lang-icon">
                                <img :src="localize.img_flag" alt="">
                            </div>
                            <div class="lang-text">
                                {{ $t(localize.lang) }}
                            </div>
                            <div class="lang-checked" v-if="locate == localize.lang">
                                <i class="ito-icon-checked-white"></i>
                            </div>
                        </div>

                    </div>
                    <div class="ito-btn-large mt-20" data-bs-dismiss="modal" @click="updateLocate()" style="width: auto; padding: 9px 40px; margin: 8px auto 0 auto;line-height: inherit;">
                        {{ $t('confirm') }}
                    </div>
                </div>
            </div>
        </div>

        <div class="loading" id="loading" v-if="isLoading">
            <img class="spinner" src="/themes/ito/images/loadding.png" alt="" />
        </div>

        <upgrade-account-modal />
        <popup-upgrade-account :forceShow="forceUpgradePopup" />

        <div class="modal fade" id="updateGradeModal" tabindex="-1" role="dialog" aria-labelledby="updateGradeModal" aria-hidden="true" data-bs-backdrop="static" data-keyboard=false>
            <div class="modal-dialog modal-dialog-centered popup-main-1" role="document" style="max-width: 657px;">
                <div class="modal-content modal-body box-shadow-main px-3 pb-3" style="padding-top: 65px;">
                    <div class="close-popup" data-bs-dismiss="modal"></div>
                    <div class="img-title">
                        <img src="/themes/ito/images/image01/grade.png" alt="">
                    </div>
                    <h3 class="popup-title">{{ $t('choose_grade_1') }}</h3>
                    <br />
                    <!--<h3 class="popup-description mb-20">{{$t('choose_grade_2')}}</h3>-->

                    <div class="grade-select-body">
                        <div class="grade-select-list">
                            <div @click="selectGrade(1)" :class="checkGradeSelected(1) ? ['grade-select-item', 'active'] : ['grade-select-item']">1
                            </div>
                            <div @click="selectGrade(2)" :class="checkGradeSelected(2) ? ['grade-select-item', 'active'] : ['grade-select-item']">2
                            </div>
                            <div @click="selectGrade(3)" :class="checkGradeSelected(3) ? ['grade-select-item', 'active'] : ['grade-select-item']">3
                            </div>
                            <div @click="selectGrade(4)" :class="checkGradeSelected(4) ? ['grade-select-item', 'active'] : ['grade-select-item']">4
                            </div>
                            <div @click="selectGrade(5)" :class="checkGradeSelected(5) ? ['grade-select-item', 'active'] : ['grade-select-item']">5
                            </div>
                        </div>
                    </div>
                    <div class="txt-error" v-if="sl_grade_err" style="font-size: 14px; margin: 5px 0px; color: #FA450F;">
                        {{ sl_grade_err }}</div>
                    <div class="text-center mt-3">
                        <!--<button class="ito-btn-large btn-test mt-20" style="width: 115px;" @click="confirmSelectGrade">-->
                        <button class="ito-btn-large btn-test mt-20" style="width: 115px;" @click="changeGrade">
                            {{ $t('confirm') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="placementModal" tabindex="-1" role="dialog" aria-labelledby="placementModal" aria-hidden="true" :data-bs-backdrop="forceUpgradePopup ? 'static' : 'true'" :data-keyboard="!forceUpgradePopup">
            <div class="modal-dialog modal-dialog-centered popup-main-1" role="document" style="max-width: 657px;">
                <div class="modal-content modal-body box-shadow-main" style="padding-top: 65px;">
                    <div v-if="!forceUpgradePopup" class="close-popup" data-bs-dismiss="modal"></div>
                    <div class="img-title">
                        <img src="/themes/ito/images/image01/grade.png" alt="">
                    </div>
                    <h3 class="popup-title-verify">{{ $t('choose_grade_3') }}</h3>
                    <h3 class="popup-title">{{ $t('choose_grade_1') }}</h3>
                    <br />

                    <div class="grade-select-body">
                        <div class="grade-select-list">
                            <div @click="selectGrade(1)" :class="checkGradeSelected(1) ? ['grade-select-item', 'active'] : ['grade-select-item']">1
                            </div>
                            <div @click="selectGrade(2)" :class="checkGradeSelected(2) ? ['grade-select-item', 'active'] : ['grade-select-item']">2
                            </div>
                            <div @click="selectGrade(3)" :class="checkGradeSelected(3) ? ['grade-select-item', 'active'] : ['grade-select-item']">3
                            </div>
                            <div @click="selectGrade(4)" :class="checkGradeSelected(4) ? ['grade-select-item', 'active'] : ['grade-select-item']">4
                            </div>
                            <div @click="selectGrade(5)" :class="checkGradeSelected(5) ? ['grade-select-item', 'active'] : ['grade-select-item']">5
                            </div>
                        </div>
                    </div>

                    <div class="text-center">
                        <button class="ito-btn-large btn-test mt-20" style="width: 150px;" @click="confirmPlacementTest">
                            {{ $t('do_placement') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="testPlacementModal" tabindex="-1" role="dialog" aria-labelledby="testPlacementModal" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered popup-main-1" role="document" style="max-width: 650px;">
                <div class="modal-content modal-body box-shadow-main">
                    <div class="close-popup" data-bs-dismiss="modal"></div>
                    <h3 class="popup-title mb-20">{{ $t('placement_test') }}</h3>
                    <div class="d-flex quick-test-box text-center">
                        <img src="/themes/ito/images/reading.svg" style="width: 150px; margin: 0 auto;">
                    </div>
                    <div class="quick-test-bottom box-shadow-main d-flex mt-20">
                        <div class="quick-test-bottom-text">
                            <div class="txt-2-rows">
                                <div class="text-right d-inline-block left-title">{{ $t('total') }}:</div>
                                <div class="d-inline-block right-text">{{ placement_test.total_question }}
                                    {{ $t('scores') }}
                                </div>
                            </div>
                            <div class="txt-2-rows">
                                <div class="text-right d-inline-block left-title">{{ $t('time_allowance') }}:</div>
                                <div class="d-inline-block right-text">{{ placement_test.time }} {{ $t('minutes') }}</div>
                            </div>
                        </div>
                        <div class="ito-btn-large btn-test mt-20" @click="placementTest">
                            {{ $t('start') }}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <daily-bonus-modal v-if="user_info.first_login == 1" :user="user_info" @updateFirstLogin="updateFirstLogin" />
        <get-reward-modal :reward="reward"></get-reward-modal>
        <err-modal :err_code="err_message"></err-modal>
        <logout-modal></logout-modal>
        <event-modal v-if="!(forceUpgradePopup && doPlacementTest)" :banners="banners" @hideBanner="hideBanner()" @closeBanner="closeBanner()"></event-modal>
        <ai-tutor v-if="aiTutorConfig" :config="aiTutorConfig" :fullname="user_info.fullname" :username="user_info.username" :grade="grade_selected" />

        <!--<audio ref="audio" src="/themes/ito/audios/musicBG-app.mp3" ></audio>-->
    </div>
</template>

<script>
import axios from "axios";
import SideBar from "../SideBar";
import NavBar from "../NavBar";
import FooterElement from "../FooterElement";
import { getConfigs, getLanguage, soundClick } from "../../utils/utils";
import { getPlacementTest, startPlacementTest } from "../../models/placement_test";
import UpgradeAccountModal from "../modal/UpgradeAccountModal";
import PopupUpgradeAccount from '../modal/PopupUpgradeAccount';
import { updateLanguage, changeGrade } from '../../models/profile';
import { getBanners } from '../../models/dashboard';

import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, isSupported } from "firebase/messaging";

import DailyBonusModal from '../modal/DailyBonusModal.vue';
import GetRewardModal from '../modal/GetRewardModal.vue';
import ErrModal from '../modal/ValidateModal.vue';
import LogoutModal from '../modal/LogoutModal.vue';
import EventModal from '../modal/EventModal.vue';
import AiTutor from '../ai_tutor/AiTutor.vue';
import ModalHost from '@/components/ModalHost.vue'
import UpdateAddressModal from "@/modals/UpdateAddressModal.vue";
import PhoneVerifyModal from "@/modals/PhoneVerifyModal.vue";
import AppIcon from "@/components/common/AppIcon.vue";
import MarqueeText from "@/components/common/MarqueeText.vue";
import moment from 'moment';

export default {
    name: "AppLayout",

    data() {
        const grade_default = localStorage.getItem('grade');
        const configs = getConfigs();
        const localizes = configs.localize || [];
        const banner_hiding = localStorage.getItem('banner_hidden') || localStorage.getItem('banner_close');

        return {
            locate: getLanguage(),
            locate_obj: null,
            user: {
                grade: 1
            },
            grade_selected: grade_default || 1,
            placement_test: {
                id: 0,
                condition_pass: 0,
                time: 0,
                total_question: 0,
            },
            configs: configs,
            localizes: localizes,
            sl_grade_err: '',
            err_message: '',
            reward: '',
            banners: [],
            banner_mkt: [],
            banner_hiding: JSON.parse(banner_hiding),
            forceUpgradePopup: false,
            isValidating: false,
        };
    },

    components: {
        UpgradeAccountModal,
        PopupUpgradeAccount,
        FooterElement,
        NavBar,
        SideBar,
        DailyBonusModal,
        GetRewardModal,
        ErrModal,
        LogoutModal,
        EventModal,
        AiTutor,
        ModalHost,
        AppIcon,
        MarqueeText
    },

    computed: {
        isLoading() {
            return this.$store.getters.isLoading
        },
        user_info() {
            return this.$store.state.user_info;
            ;
        },
        aiTutorConfig() {
            return this.user_info.package_features?.find(feature => feature.feature_code === 'ai_home_tutor')
        },
        doPlacementTest() {
            return this.user_info.placement_test === 0 && this.user_info.student_type !== 1;
        }
    },

    updated() {
        this.$nextTick(() => {
            $('#eventModal').on('hidden.bs.modal', function (e) {
                $("#dailyBonusModal").modal('show');
            })
        })
        // console.log(this.user_info)

        //if (this.user_info.first_login == 1) {
        //    $("#dailyBonusModal").modal('show');
        //}
    },

    async mounted() {
        //setInterval(this.refreshData, 2000);
        // this.grade_selected = this.user_info.grade;
        this.grade_selected = localStorage.getItem('grade') ? localStorage.getItem('grade') : this.user_info.grade;
        this.fetch();

        const firebaseSupported = await isSupported()
        if (!firebaseSupported || !('Notification' in window)) return;

        // init push noti
        const firebaseConfig = {
            apiKey: "AIzaSyDMaQnL8UUvi1O-CHCgDch22U47y_K-wIQ",
            authDomain: "ismart-pro-5357f.firebaseapp.com",
            projectId: "ismart-pro-5357f",
            storageBucket: "ismart-pro-5357f.appspot.com",
            messagingSenderId: "580103667062",
            appId: "1:580103667062:web:a59380dac56ef9a4f58e57",
            measurementId: "G-JD84SKYWPT"
        };

        const app = initializeApp(firebaseConfig);
        const messaging = getMessaging(app);
        Notification.requestPermission().then((permission) => {
            if (permission === 'granted') {
                getToken(messaging, { vapidKey: 'BGQxkHZzcAhSiVVmIHo1FE5FVqzaVKVOw2hBDu03emmXPIiO5Fg-8V-Xulu6v-SS045k3ZSNEWbnYNyK_s9763k' }).then((currentToken) => {
                    if (currentToken) {
                        window.localStorage.setItem('firebaseToken', currentToken);
                    } else {
                        console.log('No registration token available. Request permission to generate one.');
                    }
                }).catch((err) => {
                    console.log('An error occurred while retrieving token. ', err);
                });
            } else {
                console.log('Unable to get permission to notify.');
            }
        });
        localStorage.setItem("banner_close", false);
    },

    watch: {
        '$store.state.showPlacementModalFlag': function (newVal) {
            if (newVal) {
                $('#placementModal').modal('show');
                this.$store.dispatch('setShowPlacementModalFlag', false);
            }
        },
        '$route': {
            immediate: true,
            handler(newRoute) {
                this.checkUserInfoValidation();
                if (newRoute.path === '/upgrade-account' && this.doPlacementTest) {
                    this.$store.dispatch('setShowPlacementModalFlag', true);
                    this.forceUpgradePopup = true;
                } else {
                    this.forceUpgradePopup = false;
                    this.$store.dispatch('setShowPlacementModalFlag', false);
                }
            }
        },
        'user_info': {
            immediate: true,
            handler(newUserInfo) {
                if (newUserInfo && newUserInfo.name !== 'Guest') {
                    this.checkUserInfoValidation();
                }
            }
        }
    },

    methods: {
        moment,
        async fetch() {
            await this.checkUserInfoValidation();
            if (this.user_info.contest_info?.id == 0 || this.user_info.phone_verified == 1) {
                this.getBanners()
                this.handleGACustomEvent();
            }
        },

        async checkUserInfoValidation() {
            if (!this.user_info || this.user_info.name === 'Guest' || this.user_info.contest_info?.id == 0) {
                return;
            }
            if (this.isValidating) {
                return;
            }

            this.isValidating = true;
            try {
                const { province, ward, school, class: userClass } = this.user_info;

                const isAddressIncomplete = (!province || province.id === 0) ||
                    (!ward || ward.id === 0) ||
                    !school ||
                    !userClass;

                if (isAddressIncomplete) {
                    await this.$modal.open(UpdateAddressModal, {
                        options: {
                            customSize: {
                                width: '500px',
                                maxWidth: '500px'
                            },
                            centered: true, backdrop: 'static', keyboard: false
                        },
                    })
                }

                if (this.user_info.phone_verified == 0 && this.user_info.student_type !== 1 && this.$route.name !== 'account_verify') {
                    await this.showPhoneVerifyModal();
                }
            } catch (err) {
                console.error('Validation error:', err);
            } finally {
                this.isValidating = false;
            }
        },

        refreshData() {
            if (this.$refs.audio) {
                this.$refs.audio.play();

                document.getElementById('footer').click();
            }
        },

        updateFirstLogin(status, reward) {
            if (status == 0) {
                this.user_info.first_login = status;
                this.reward = reward;
                $('#getRewardedModal').modal('show');
            }
            else {
                this.err_message = reward
                $('#getValidateModal').modal('show');
            }
        },

        getSoundClick() {
            soundClick();
        },

        confirmPlacementTest() {
            const that = this;
            that.getSoundClick();
            that.$store.commit("setLoading", true);
            const path = '/placement-test/' + that.grade_selected
            if (this.$route.path !== path) {
                this.$router.push(path)
                $('#placementModal').modal("hide");
            } else {
                that.$store.commit("setLoading", false);
                $('#placementModal').modal("hide");
            }
        },

        placementTest() {
            const that = this;
            that.getSoundClick();
            that.$store.commit("setLoading", true);
            startPlacementTest({
                id: this.placement_test.id
            }).then((response) => {
                that.$store.commit("setLoading", false);

                if (response.data.code != 0) {
                    return;
                }

                $('#testPlacementModal').modal("hide");
            }).catch(({ response }) => {
                that.$store.commit("setLoading", false);

                console.error(response);
            });
        },

        selectGrade(grade) {
            this.grade_selected = grade;
        },

        checkGradeSelected(grade) {
            return this.grade_selected == grade;
        },

        setLocate(e) {
            this.getSoundClick();
            this.locate_obj = e;
            this.locate = e.lang;
        },

        updateLocate() {
            const that = this;
            this.getSoundClick();
            localStorage.setItem('lang', this.locate);

            if (that.locate_obj != null) {
                that.$store.commit("setLoading", true);
                updateLanguage({
                    id: that.locate_obj.id,
                    is_raw: true
                }).then((response) => {
                    if (response.data.code != 0) {
                        return;
                    }
                    this.$i18n.locale = this.locate

                }).catch(({ response }) => {
                    console.error(response);
                }).finally(() => {
                    that.$store.commit("setLoading", false);
                });
            }

        },
        // = 0 -> có thể change grade
        // = 1 -> cần hoàn thành các bài học
        // = 2 -> cần làm placement test
        // = 3 -> cần làm final test
        // = 4 -> chưa đủ điều kiện để học lớp này"
        changeGrade() {

            const that = this;
            that.$store.commit("setLoading", true);
            const params = {
                'grade': that.grade_selected
            }
            changeGrade(
                params
            ).then((response) => {
                that.$store.commit("setLoading", false);
                if (response.data.code != 0) {
                    return;
                }
                switch (parseInt(response.data.results.status)) {
                    case 0:
                        localStorage.setItem('grade', that.grade_selected);
                        $('#updateGradeModal').modal("hide");
                        window.location.href = '/';
                        break;
                    case 1:
                        // this.sl_grade_err = 'You need to pass the final test of grade '+that.user_info.grade;
                        this.sl_grade_err = this.$i18n.t('change_grade_error_ipro');;
                        break;
                    case 2:
                        // that.$store.commit("setLoading", true);
                        // const path = '/placement-test/' + that.grade_selected;
                        // if (that.$route.path !== path) {
                        //     that.$router.push(path)
                        //     $('#updateGradeModal').modal("hide");
                        // } else {
                        //     that.$store.commit("setLoading", false);
                        //     $('#updateGradeModal').modal("hide");
                        // }
                        localStorage.setItem('grade', that.grade_selected);
                        $('#updateGradeModal').modal("hide");
                        window.location.href = '/';
                        break;
                    case 3:
                        // this.sl_grade_err = 'You need to pass the final test of grade '+that.user_info.grade;
                        this.sl_grade_err = this.$i18n.t('change_grade_error_ipro');;
                        break;
                    case 4:
                        // this.sl_grade_err = 'You can not study grade '+that.grade_selected;
                        this.sl_grade_err = this.$i18n.t('change_grade_error_ipro');;
                        break;
                    default:
                        $('#updateGradeModal').modal("hide");
                        break;
                }
            });
        },
        getBanners() {
            let params = {}
            axios.all([getBanners(params)]).then(
                axios.spread((response) => {
                    if (response.data.code != 0) {
                        return;
                    }
                    var banner = [];
                    var banner_mkt = [];
                    const banners = response.data.results || [];
                    banners.forEach((item) => {
                        var image = this.getBannerImage(item.banner_url)
                        item.image = image
                        if (item.category == 'notify_banner') {
                            banner.push(item);
                        } else if (item.category == 'notify_banner_mkt') {
                            banner_mkt.push(item);
                        }
                    })
                    this.banners = banner;
                    this.banner_mkt = banner_mkt;
                    const that = this;
                    let banner_hiding = that.banner_hiding

                    if (!banner_hiding && (banners.length > 0 || banner_mkt.length > 0)) {
                        $('#eventModal').modal('show');
                    }
                    if (this.user_info.first_login == 1 && banner_hiding) {
                        $("#dailyBonusModal").modal('show');
                    }
                })
            );
        },
        getBannerImage(images) {
            images = JSON.parse(images);
            var lang = localStorage.getItem('lang');
            var imageStyleObject = {
                'content': 'url("' + images[lang] + '")',
            }
            return imageStyleObject
        },
        hideBanner() {
            this.banner_hiding = true;
            localStorage.setItem("banner_hidden", true);
        },
        closeBanner() {
            this.banner_hiding = true;
            localStorage.setItem("banner_close", true);
        },
        handleGACustomEvent() {
            if (this.user_info.user_id) {
                var element = 'IP1_W_0000'
                var user_id = this.user_info.user_id || '';
                var school_id_ref = this.user_info.school_id_ref || '';
                var grade_id = this.user_info.grade_code || '';
                var class_id = this.user_info.class_code || '';
                var params = {
                    'w_user_id': user_id,
                    'school_id': school_id_ref,
                    'grade_id': grade_id,
                    'class_id': class_id
                };
                params[element] = user_id + ((user_id != '') ? '|' : '') + school_id_ref + '|' + grade_id + '|' + class_id;
                gtag('event', element, params);
            }

        },
        showBackdrop() {
            if (document.getElementById('popupUpgradeBackdrop')) return;
            const backdrop = document.createElement('div');
            backdrop.id = 'popupUpgradeBackdrop';
            backdrop.className = 'modal-backdrop fade show';
            backdrop.style.zIndex = '20000';
            if (!this.forceShow) {
                backdrop.addEventListener('click', this.close);
            }
            document.body.appendChild(backdrop);
            if (this.$el) this.$el.style.zIndex = '20001';
        },
        showPhoneVerifyModal() {
            return this.$modal.open(PhoneVerifyModal, {
                options: {
                    customSize: {
                        width: '550px',
                        maxWidth: '550px'
                    },
                    centered: true, backdrop: 'static', keyboard: false
                },
            })
        }
    }
}
</script>
<style scoped>
.left-corner {
    position: fixed;
    width: 13vw;
    max-width: 163px;
    z-index: 2;
    bottom: 30px;
    left: 105px;
    animation: 1s ease-out 0s 1 slideInFromLeft;
    content: var(--left-corner-image);
}

.right-corner {
    position: fixed;
    width: 13vw;
    max-width: 177px;
    top: 85px;
    right: 23px;
    animation: 1s ease-out 0s 1 slideInFromRight;
    content: var(--right-corner-image);
}


.banner-text {
    width: 100%;
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 65px;
    z-index: 1;
    height: 47px;
    flex-shrink: 0;
    background: rgba(255, 255, 255, 0.7);

    animation-name: slidedown;
    animation-duration: 1s;
}

.banner-text .banner-link {
    color: #F04821;
    text-align: center;
    font-family: Nunito;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    /* text-decoration-line: underline; */
}

.banner-text span.banner-btn {
    display: inline-block;
    box-shadow: 0px 2px 0px 0px #ffffff33 inset;
    box-shadow: 4px 4px 0px 0px #0000000d;
    background: linear-gradient(180deg, #45BCFF 0%, #00A3FF 100%);
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: 0.02em;
    text-align: center;
    color: #FFFFFF !important;
    padding: 8px 12px;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    width: fit-content;
    border-radius: 30px;
    margin-left: 10px;
}

@keyframes slidedown {
    from {
        top: 47px;
    }

    to {
        top: 65px;
    }
}


@media screen and (max-width: 1366px) {

    .left-corner,
    .right-corner {
        display: none;
    }
}

@keyframes slideInFromLeft {
    0% {
        transform: translateX(-100%);
    }

    100% {
        transform: translateX(0);
    }
}

@keyframes slideInFromRight {
    0% {
        transform: translateX(100%);
    }

    100% {
        transform: translateX(0);
    }
}
</style>